import React from "react";
import { AlertCircle, Inbox, Lock, Search } from "react-feather";
import { Button, Card, CardBody, Spinner } from "reactstrap";

const StateCard = ({ icon: Icon, title, children, action, tone = "secondary", role = "status" }) => (
  <Card className="text-center border-0 shadow-sm">
    <CardBody className="py-5" role={role}>
      <Icon size={36} className={`text-${tone} mb-3`} aria-hidden="true" />
      <h4>{title}</h4>
      <p className="text-muted mb-3">{children}</p>
      {action}
    </CardBody>
  </Card>
);

export const LoadingState = ({ label = "Loading workspace" }) => <div className="text-center py-5" role="status"><Spinner color="primary" /><span className="visually-hidden">{label}</span><p className="text-muted mt-2 mb-0">{label}…</p></div>;
export const EmptyState = ({ title = "Nothing here yet", children = "There is no information to display." }) => <StateCard icon={Inbox} title={title}>{children}</StateCard>;
export const ErrorState = ({ message, onRetry }) => <StateCard icon={AlertCircle} title="Unable to load this page" tone="danger" role="alert" action={onRetry && <Button color="primary" onClick={onRetry}>Try again</Button>}>{message || "Please try again."}</StateCard>;
export const UnauthorizedState = () => <StateCard icon={Lock} title="Access denied" tone="warning" role="alert">You do not have permission to view this area. Access is also enforced by the Laravel API.</StateCard>;
export const NotFoundState = () => <StateCard icon={Search} title="Page not found">The page you requested does not exist.</StateCard>;
